import { processLogout } from "../api/cventapi";
import "./Footer.css";
import { useLocation, useNavigate } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const pathName = () => {
    return location.pathname === "/" || location.pathname === "/nbc" || location.pathname === "/abc";
  };

  const isDashboardPage = () => {
    return location.pathname === "/nbc/dashboard";
  };

  const logout = () => {
    // Clear user details from localStorage
    localStorage.removeItem("userdetail");

    processLogout();

    if (isDashboardPage()) {
      navigate("/reportLogin");
    } else if (location.pathname.startsWith("/abc")) {
      navigate("/abc");
    } else {
      navigate("/nbc");
    }
  };

  return (
    <div className="footer4 sb-footer b-t">
      <div className="container">
        <div className="f4-bottom-bar">
          <div className="row">
            <div className="col-md-12">
              <div className="d-flex font-14">
                {pathName() === false && (
                  <button id="logout-button" onClick={logout}>
                    Logout
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
